import commonEnvironment from 'config/de/common-environment';
import paypal from 'config/paypal';
import { ShopEnvironment } from 'config/types';

export default {
  ...commonEnvironment,
  apiEndpoint: 'https://api.petsdeli.de',
  backInStockUrl: 'https://jzk1.myshopify.com',
  contentfulEnv: 'master',
  pdexEndpoint: 'https://merchant.petsdeli.de',
  foodaidEndpoint: 'https://api.petsdeli.de/fube-live-2023-04',
  ninetailedEnv: 'main',
  oosEndpoint: 'https://api.oos.petsdeli.de',
  paypalClientId: paypal.production,
  shopifyUrl: 'https://shop.petsdeli.de',
  midaKey: 'nvmGW7eJdkWL9dw81xXQKA',
  gtmScriptUrl: 'https://sst.petsdeli.de/g27fwnhmpv.js?tg=NK69QT6',
  gtmNoScriptUrl: 'https://sst.petsdeli.de/g27fwnhmpv.html?tg=NK69QT6',
} satisfies ShopEnvironment;
